import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
} from "@mui/material";
import { Eye, EyeOff, GripVertical, Settings } from "lucide-react";
import React from "react";

const ColumnManagingModal = ({
  showColumnManager,
  setShowColumnManager,
  columnVisibilityModel,
  columnsOrder,
  handleDragEnd,
  handleDragStart,
  handleDragOver,
  handleDragLeave,
  handleDrop,
  isDragging,
  dragOverIndex,
  draggedColumn,
  toggleColumnVisibility,
  resetColumnOrder,
  getColumnDisplayName,
  moveColumn,
}) => {
  return (
    <Dialog
      open={showColumnManager}
      onClose={() => setShowColumnManager(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle className="flex items-center gap-2">
        <Settings className="w-5 h-5" />
        Manage Columns
      </DialogTitle>
      <DialogContent>
        <div className="space-y-2 mt-4">
          <div className="text-sm font-medium text-gray-700 mb-3">
            Column Order & Visibility
          </div>
          {columnsOrder?.map((field, index) => (
            <div
              key={field}
              draggable
              onDragStart={(e) => handleDragStart(e, field)}
              onDragOver={(e) => handleDragOver(e, index)}
              onDragLeave={handleDragLeave}
              onDrop={(e) => handleDrop(e, index)}
              onDragEnd={handleDragEnd}
              className={`flex items-center gap-3 p-3 bg-white border rounded-lg ${
                isDragging ? " cursor-grabbing" : "cursor-grab"
              } hover:bg-gray-50 transition-colors ${
                dragOverIndex === index
                  ? "border-blue-400 bg-blue-50"
                  : "border-gray-200"
              } ${draggedColumn === field ? "opacity-50" : ""}`}
            >
              <GripVertical className="w-4 h-4 text-gray-400" />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={columnVisibilityModel[field] !== false}
                    onChange={() => toggleColumnVisibility(field)}
                    size="small"
                  />
                }
                label=""
                className="m-0"
              />
              <div className="flex items-center gap-2 flex-1">
                {columnVisibilityModel[field] !== false ? (
                  <Eye className="w-4 h-4 text-green-600" />
                ) : (
                  <EyeOff className="w-4 h-4 text-gray-400" />
                )}
                <span className="text-sm font-medium capitalize">
                  {getColumnDisplayName(field)}
                </span>
              </div>

              <div className="flex gap-1">
                {index > 0 && (
                  <button
                    onClick={() => moveColumn(index, index - 1)}
                    className="text-xs px-2 py-1 bg-gray-100 hover:bg-gray-200 rounded"
                  >
                    ↑
                  </button>
                )}
                {index < columnsOrder.length - 1 && (
                  <button
                    onClick={() => moveColumn(index, index + 1)}
                    className="text-xs px-2 py-1 bg-gray-100 hover:bg-gray-200 rounded"
                  >
                    ↓
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={resetColumnOrder}
          color="error"
          variant="outlined"
          sx={{ borderRadius: 2 }}
        >
          Reset to Default
        </Button>
        <Button
          onClick={() => setShowColumnManager(false)}
          variant="contained"
          sx={{ borderRadius: 2 }}
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ColumnManagingModal;
